module.exports = __webpack_public_path__ + "72b2c6610eb577ac8b66ae3e523b544e.pdf";